<template>
  <div class="z-transfer">
    <div class="z-transfer-box">
      <div
        v-for="item in lastData"
        :key="item.key"
        :class="$addClass('z-transfer-item', [lastChoose.find((key) => key === item.key), 'on'])"
        @click="onClick(item.key)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="z-transfer-actions">
      <button type="button" :disabled="lastChoose.length <= 0" @click="onChange()">&gt;</button>
      <button type="button" :disabled="targetChoose.length <= 0" @click="onChange(true)">
        &lt;
      </button>
    </div>
    <div class="z-transfer-box">
      <div
        v-for="item in targetData"
        :key="item.key"
        :class="$addClass('z-transfer-item', [targetChoose.find((key) => key === item.key), 'on'])"
        @click="onClick(item.key, true)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZTransfer',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    targets: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      lastData: [],
      targetData: [],
      lastChoose: [],
      targetChoose: []
    }
  },
  beforeMount() {
    this.flatData(this.data, [...this.targets])
  },
  methods: {
    flatData(data, targets) {
      const lastData = []
      const targetData = []
      const newTarget = this.max > -1 ? targets.splice(0, this.max) : targets

      data.forEach((item) => {
        const inTarget = newTarget.find((key) => key === item.key)
        if (inTarget !== undefined) {
          targetData.push(item)
        } else {
          lastData.push(item)
        }
      })

      this.lastData = lastData
      this.targetData = targetData
    },
    onClick(key, isTarget) {
      const targetChoose = [...this.targetChoose]
      const lastChoose = [...this.lastChoose]

      if (isTarget) {
        if (targetChoose.indexOf(key) !== -1) {
          targetChoose.splice(targetChoose.indexOf(key), 1)
        } else {
          targetChoose.push(key)
        }
      } else {
        if (lastChoose.indexOf(key) !== -1) {
          lastChoose.splice(lastChoose.indexOf(key), 1)
        } else {
          if (!(this.max > -1 && this.targetData.length + lastChoose.length >= this.max)) {
            lastChoose.push(key)
          }
        }
      }

      this.targetChoose = targetChoose
      this.lastChoose = lastChoose
    },
    onChange(isTarget) {
      let last = [],
        to = []

      if (isTarget) {
        this.targetData.forEach((item) => {
          if (this.targetChoose.find((key) => key === item.key) !== undefined) {
            to.push(item)
          } else {
            last.push(item)
          }
        })
        this.lastData = [...this.lastData, ...to].sort((a, b) => a.sort - b.sort)
        this.targetData = last
        this.targetChoose = []
      } else {
        this.lastData.forEach((item) => {
          if (this.lastChoose.find((key) => key === item.key) !== undefined) {
            to.push(item)
          } else {
            last.push(item)
          }
        })
        this.targetData = [...to, ...this.targetData]
        this.lastData = last
        this.lastChoose = []
      }

      this.$emit(
        'change',
        this.targetData.map((item) => item.key)
      )
    }
  }
}
</script>

<style lang="postcss">
.z-transfer {
  display: inline-block;
  vertical-align: top;

  .z-transfer-box {
    display: inline-block;
    vertical-align: middle;
    width: 150px;
    height: 200px;
    overflow-y: auto;
    border: 1px solid #e4e4e4;
    border-radius: 5px;
  }

  .z-transfer-item {
    padding: 5px 10px;
    cursor: pointer;
    user-select: none;

    &:hover {
      background-color: #f3f3f3;
    }

    &.on {
      background-color: #eee;
    }
  }

  .z-transfer-actions {
    width: 23px;
    margin: 0 10px;
    display: inline-block;
    vertical-align: middle;

    button {
      border: 1px solid #ddd;
      background-color: #fff;
      width: 23px;
      height: 23px;
      line-height: 23px;
      border-radius: 3px;

      &:disabled {
        color: #ccc;
        border-color: #e4e4e4;
        cursor: not-allowed;
      }
    }
  }
}
</style>
